import { render, staticRenderFns } from "./DetailsProductSlide.vue?vue&type=template&id=383450f4&scoped=true&"
import script from "./DetailsProductSlide.vue?vue&type=script&lang=js&"
export * from "./DetailsProductSlide.vue?vue&type=script&lang=js&"
import style0 from "./DetailsProductSlide.vue?vue&type=style&index=0&id=383450f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383450f4",
  null
  
)

export default component.exports